import { isArray } from 'util';
import { mapCollection } from '../../utils/collection.utils';
import { parseNumber } from '../../utils/number.utils';
import { SaleOfferBearing } from '../sale-offer-bearing';
import { SaleOfferBearingVisibilityBuilder } from './sale-offer-bearing-visibility-builder';

export class SaleOfferBearingBuilder {
  static fromJson(json): SaleOfferBearing {
    return (json) ? new SaleOfferBearing(
        json.hash,
        json.saleOfferHash,
        parseNumber(json.bearingDate),
        json.observations,
        json.loadingCustomerHash,
        json.loadingCustomerBusinessName,
        json.loadingCustomerNif,
        json.loadingPlace,
        json.unloadingCustomerHash,
        json.unloadingCustomerBusinessName,
        json.unloadingPlace,
        json.unloadingCustomerNif,
        (isArray(json.saleOfferBearingVisibilities)) ? mapCollection(
            SaleOfferBearingVisibilityBuilder.fromJson, json.saleOfferBearingVisibilities) : [],
    ) : null;
  }

  static fromJsonList(list): SaleOfferBearing[] {
    return (isArray(list)) ? mapCollection(SaleOfferBearingBuilder.fromJson, list) : [];
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/builders/sale-offer-bearing-builder.ts